import React from 'react'
import './css/CaseStudy.css'
import Prodigy from "../../../assets/downloads/Case-Study/D365 for a Healthcare provider.pdf";
import KHA from '../../../assets/downloads/Case-Study/CRM development for Australian Nonprofit.pdf';
import eBookNonprofitCRM from '../../../assets/downloads/Case-Study/eBook-Nonprofit-CRM.pdf';
import eBookMembershipManagement from '../../../assets/downloads/Case-Study/eBook-Nonprofit-Transforms-Membership-Management-with-Right-Cause-CRM.pdf';


const CaseStudy = () => {
    return (
        <div className="row">
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Case study</h5>
                        <p className="card-text">How Right Cause Leveraged Power Platform to Build a Scalable and Patient-Centric Portal for A Leading Healthcare Services Client</p>
                        <a href={Prodigy} download="D365 for a Healthcare provider.pdf" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Case study</h5>
                        <p className="card-text">Digital Transformation via the Power Portal Platform Saves Time and Unlocks Insights for Leading Healthcare Non-Profit</p>
                        <a href={KHA} download="CRM development for Australian Nonprofit.pdf" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">eBook</h5>
                        <p className="card-text">This eBook shows when exactly nonprofits need a CRM to streamline operations. Learn signs like scattered donor data, lack of visibility, tough reporting and no mobile access. Then get an overview of Right Cause, a powerful Microsoft Dynamics 365 based nonprofit CRM. It features donation management, grants, events, robust reporting and more to maximize your valuable resources.</p>
                        <a href={eBookNonprofitCRM} download="eBook-Nonprofit-CRM.pdf" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">eBook</h5>
                        <p className="card-text">This case study explains how a nonprofit organization improved membership management, engagement, and retention using Right Cause CRM built on Microsoft Dynamics 365.</p>
                        <a href={eBookMembershipManagement} download="eBook-Nonprofit-CRM.pdf" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaseStudy